<template>
<div>
</div>
</template>

<script>
import { useClient, useMutation } from 'villus';
import { gql } from 'graphql-tag';
import { computed, reactive } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'updateUserDataRecentTrainingMutation',

  setup() {
    const store = useStore();

    useClient({
      url: process.env.VUE_APP_STRAPI,
    });

    const updateUserDataRecentTrainingMutation = gql`
      mutation($userDataId: ID!, $recentTrainings: [ComponentTrainingTrainingInput]) {
        updateUserData(
          id: $userDataId
          data: {
            recentTrainings: $recentTrainings
          }
        ) {
          data {
            attributes {
              datenschutzVersion
            }
          }
        }
      }
      `;

    const context = reactive({
      headers: computed(() => store.state.auth.headers),
    });

    const { execute: updateUserDataRecentTraining } = useMutation(updateUserDataRecentTrainingMutation, {
      context,
    });

    store.commit('setStrapiExecutionHandler', { item: 'updateUserDataRecentTraining', result: updateUserDataRecentTraining });
  },
};
</script>
